<template>
	<div class="floatTip">
		<!-- 悬浮区域 -->
		<div class="floatLeft" :style="{top:showTop +'px'}">
			<div class="" v-for="(item,index) in imgList" :key="index" v-show="floatShow === index">
				<div class="float_body">
					<img :src="item.picture" alt="" srcset="">
				</div>
			</div>
		</div>

		<div class="floatTop" @mouseleave="floatShow = ''">
			<div class="floatTop fixedBox_view" style="box-shadow: none;" @mouseenter="setFloatShow(0)">
				<img src="../assets/img/shift/dyh.png" style="width: 16px;height: 20px;" alt="">
				<p>订阅号</p>
			</div>
			<div class="floatTop fixedBox_view" style="box-shadow: none;" @mouseenter="setFloatShow(1)">
				<img src="../assets/img/shift/service.png" style="width: 20px;height: 20px;" alt="">
				<p>服务号</p>
			</div>
		</div>

		<!-- 返回顶部 -->
		<a href="#app" style="text-decoration: none;">
			<div class="floatBootm">
				<img src="../assets/img/shift/backtop.png" style="width: 18px;height: 17px;" alt="">
				<p>返回顶部</p>
			</div>
		</a>
	</div>

</template>

<script>
	import {
		apiRequest
	} from '../assets/js/axios/request.js'

	export default {
		data() {
			return {
				showTop: 0,
				floatShow: -1,
				imgList: []
			}
		},
		created() {
			this.getWorkShow()
		},
		methods: {
			// 设置显示
			setFloatShow(index) {
				const setTop = document.querySelectorAll('.fixedBox_view')[index]
				this.showTop = setTop.offsetTop
				this.floatShow = index
			},
			// 首页工作展示-业务活动
			async getWorkShow() {
				await apiRequest({
					method: 'post',
					url: '/adminapi/web/get-web-work-area',
					data: {
						column_code: 'C143F5FC-D31F-FAC0-4E97-FA74A932968D'
					},
					success: (res) => {
						// console.log('业务活动', res)
						this.imgList = res.data
					}
				})
			},
		}
	}
</script>

<style scoped>
	/* 悬浮窗 */
	.floatLeft {
		position: absolute;
		z-index: 21;
		right: 80px;
		background-color: #fff;
		box-shadow: 0 5px 15px rgb(0 0 0 / 50%);
		border-radius: 6px;
		overflow: hidden;
	}
	.float_body {
		padding: 10px;
		width: max-content;
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
	}

	.fixedBox_view {
		cursor: pointer;
	}

	.floatTip {
		position: fixed;
		right: 38px;
		top: 470px;
		z-index: 999;
	}

	.floatTop {
		width: 56px;
		height: 115px;
		background: #FFFFFF;
		box-shadow: 0px 1px 10px 0px rgba(184, 184, 184, 0.5000);
		border-radius: 8px;
		display: flex;
		flex-flow: column;
		align-items: center;
		justify-content: center;
	}

	.floatBootm {
		margin-top: 14px;
		width: 56px;
		height: 58px;
		background: #FFFFFF;
		box-shadow: 0px 1px 10px 0px rgba(184, 184, 184, 0.5000);
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-flow: column;
	}

	.floatTop img,
	.floatBootm img {
		cursor: pointer;
	}

	.floatTop p,
	.floatBootm p {
		font-size: 10px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #125DB2;
		line-height: 14px;
		cursor: pointer;
	}
</style>
